import type { IFilterSelection } from 'Types/aempsched/aempschedDay';
import Axios, { type AxiosInstance, type AxiosPromise, type AxiosRequestConfig } from 'axios';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
import { club } from '@/utils/club';

const prospectSchedulesConfig = window.lt.api.prospectSchedules as ltFramework.IDictionary;

export const ScheduleServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: prospectSchedulesConfig.url,
	headers: {
		'Ocp-Apim-Subscription-Key': prospectSchedulesConfig.key
	}
});

export default class ScheduleService {
	public async getSchedule(
		startDate: string,
		endDate: string,
		filters: IFilterSelection[],
		axiosRequestConfig?: AxiosRequestConfig
	): AxiosPromise {
		const params = new URLSearchParams(`club=${club.mmsClubId}&start=${startDate}&end=${endDate}`);

		filters?.forEach((filter: IFilterSelection) => {
			if (filter.group && filter.name) {
				params.append(filter.group, filter.name);
			}
		});

		return ScheduleServiceAxiosInstance.get(
			`/prospect/schedules?${params.toString()}`,
			axiosRequestConfig
		);
	}
}

export const scheduleService = new ScheduleService();
